import React from "react";
import { Button, Column, Columns, Control, Field, Select } from "@allxsmith/bestax-bulma";


function KeyPicker({keys, selectedKey, onKeyChange, onClear, filterField, filter, disabled, spare=false}) {

  let filteredKeys = keys.results;
  if (filter) {
    filteredKeys = filteredKeys.filter((key) => (key.board === filterField || key.board === "EXTERNAL"))
  }
  filteredKeys = filteredKeys.filter((key) => (key.spare === spare))

  return (
    <div>
      <Columns isMultiline>
        <Column>
          <label className="label">{spare ? 'Spare Key Selector' : 'Key Selector'}</label>
          <Field className={'has-addons'}>
            <Control>
              <Select
                name={spare ? "spare_key" : "key"}
                value={selectedKey ? selectedKey.id : 0}
                onChange={e => onKeyChange(e)}
                disabled={disabled}
              >
                <option></option>
                {filteredKeys.map(value => (
                  <option key={value.id} value={value.id}>
                    {spare ? value.board + " " + value.key_number : value.board === "EXTERNAL" ? value.board + " " + value.key_number : value.key_number}
                  </option>
                ))}
              </Select>
            </Control>
            <Control>
              <Button
                  className="small-row-white"
                  color="danger"
                  disabled={disabled}
                  onClick={() => {
                    onClear(spare)
                  }}
              >
                  Unassign Key
              </Button>
            </Control>
          </Field>
        </Column>
      </Columns>

    </div>
  );


}

export default KeyPicker;